import { MdDarkMode } from "react-icons/md";
import { CiLight } from "react-icons/ci";

export function ButtonDarkMode({changeDarkMode, isDarkMode}) {
    return(
        <section className="dark-mode py-4 px-2 d-flex justify-content-end">
            <button className="dark-mode__btn d-flex justify-content-center align-items-center" onClick={changeDarkMode}>
                {isDarkMode?<CiLight />:<MdDarkMode />}
            </button>
        </section>
    );
}